module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Mary-Queen-of-Scots.c8f4797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Mary-Queen-of-Scots.jpg
// module id = kC+Y
// module chunks = 0